import logo from '../../images/logo.png'
import React, { useState, useEffect } from 'react';
import './landingpage.css'
import { Button, Drawer, Layout } from 'antd';
import { Content, Footer, Header } from 'antd/lib/layout/layout';
import { Link } from 'react-router-dom';
import Home from '../../components/home/Home';
import How from '../../components/how/How';
import AboutUs from '../../components/aboutus/AboutUs';
import { GithubOutlined, MenuOutlined } from '@ant-design/icons';
import NavbarMenu from '../../components/navbar/navbarmenu/NavbarMenu';
import CollapsedTabs from '../../components/navbar/CollapsedTabs';

const LandingPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState('home')
    const [activeTabContent, setActiveTabContent] = useState<undefined | JSX.Element>(undefined)
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const tabs = {
            HOME: "home",
            HOW: "how",
            ABOUT: "about",
        }
    
        switch (activeTab) {
            case tabs.HOME:
                setActiveTabContent(<Home/>)
                break;
            case tabs.HOW:
                setActiveTabContent(<How/>)
                break;
            case tabs.ABOUT:
                setActiveTabContent(<AboutUs/>)
                break;        
        }
    }, [activeTab])
    

    return(
        <Layout className="site-layout-background">
            <Header className="header navbar-layout-background landing-page-navbar" >
                <div className='navbar-content'>
                    <div className='logo-area'>
                        <Button
                                className="menu-button"
                                type="text"
                                icon={<MenuOutlined/>}
                                onClick={() => setVisible(true)}
                            />
                        <Drawer
                            title={null}
                            placement="top"
                            onClose={() => setVisible(false)}
                            visible={visible}
                            bodyStyle={{padding: '0px', margin:'0px'}}
                            closable={false}
                            height={144}
                        > 
                            <CollapsedTabs setVisible={setVisible} setActiveTab={setActiveTab}/>
                        </Drawer>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <img className='logo' alt='logo' src={logo} />
                        </Link>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <h1>FairVote</h1>
                        </Link>
                    </div>
                    <div style={{display: 'flex'}}>
                        <div>
                            <NavbarMenu setActiveTab={setActiveTab}/>
                        </div>
                        <Link to='/signup' style={{ textDecoration: 'none' }}>
                            <Button type="primary">
                                Get Started
                            </Button>
                        </Link>  
                    </div>
                </div>
            </Header>
            <Content>
                <div>
                    {activeTabContent}
                </div>
            </Content>
            
            <Footer className="site-layout-background" style={{ textAlign: 'center' }}>
                <div>
                    <a href='https://github.com/codeuniversity/fairvote'>
                        <GithubOutlined/>
                    </a>
                </div>
                FairVote ©2021 Created by FairVote
            </Footer>
        </Layout>
    )
};

export default LandingPage;